import React, {useEffect, useState} from "react";

import {RouteHelper} from "../../route/RouteHelper";
import {Helmet} from "react-helmet";
import {css} from "@emotion/css";
import {UserService} from "../../serverService/userService/UserService";
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {useDebounce} from "@uidotdev/usehooks";
import {
    convertUniversalDateTimeToPersianDateTime,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoChipTypes,
    RaikoCustomSimpleChip,
    RaikoCustomTable,
    RaikoGridOneColumn,
    RaikoGridTwoColumn,
    RaikoMobileInputOutlined,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined,
    showErrorMessage,
    RaikoTableTitleContainer,
    RaikoDefaultDialogPage,
    RaikoBaseDialogContentContainer,
    DialogSize,
    RaikoGridFourColumn,
    RaikoCardInfoTypeOne,
    RaikoCardInfoTypeOneStatusTypes,
    RaikoCardInfoTypeOneItemGenerator,
    RaikoGridThreeColumn,
    RaikoTableSearchContainer
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import UserInstallationSummary from "../dashboard/userInstallationSummary/UserInstallationSummary";
import UserStatistics from "../../component/userStatistics/UserStatistics";
import avatar from "../../assets/images/avatar.svg"

export default function UsersList() {


    // let page = 0
    const size = 30

    const [isLoading, setIsLoading] = useState(false)
    const [usersListData, setUsersListData] = useState([])
    const [pageCount, setPageCount] = useState(0);
    const [numberOfItems, setNumberOfItems] = useState("");
    const [searchParams, setSearchParams] = useSearchParams();
    const [fullNameFilter, setFullNameFilter] = useState("");
    const [phoneNumberFilter, setPhoneNumberFilter] = useState("")
    const pageFromUrl = Number(searchParams.get("page")) || 1;
    const [page, setPage] = useState(pageFromUrl);
    const _pageFilter = useDebounce(page, 100)

    const _fullNameFilter = useDebounce(fullNameFilter, 500);
    const _phoneNumberFilter = useDebounce(phoneNumberFilter, 500)

    console.log("page", page)


    const service = new UserService()

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getUsersListFromServer()
            checkingFiltersAndSearches()
        }
    }, [_pageFilter, _fullNameFilter, _phoneNumberFilter]);


    useEffect(() => {
        if (searchParams && searchParams.get("page") && Number(searchParams.get("page")) !== page) {
            setPage(Number(searchParams.get("page")))
        }
    }, [searchParams]);


    function preparationRowsUsersTable(id, number, fullName, phoneNumber, nationalCode, signupAtDatePersian, signupAtTimePersian, enabled, avatar, province, city, displayName) {
        return {
            id: id,
            number: number,
            fullName: fullName ? fullName : "-",
            phoneNumber: phoneNumber,
            nationalCode: nationalCode,
            avatar,
            province,
            city,
            displayName: displayName ? displayName : '-',
            signupAt: `${signupAtTimePersian ? signupAtTimePersian.slice(0, 8) : ""} ${signupAtDatePersian}`,
            enabled: enabled ?
                <RaikoCustomSimpleChip title={"فعال"} type={RaikoChipTypes.success}/>
                : <RaikoCustomSimpleChip title={"غیر فعال"} type={RaikoChipTypes.error}/>,
        }
    }

    function getUsersListFromServer() {
        setIsLoading(true)
        service.getUsersList(
            _pageFilter - 1,
            size,
            _fullNameFilter,
            _phoneNumberFilter
        ).then(
            response => {
                setPageCount(response.totalPage)
                setNumberOfItems(response.numberOfItems)
                setUsersListData([])
                response.data.map((item, index) => {
                    setUsersListData(prevState => [
                        ...prevState,
                        preparationRowsUsersTable(
                            item.id,
                            ((page - 1) * size) + index + 1,
                            item.firstName && item.lastName ? `${item.firstName} ${item.lastName}` : "کاربر بی نام",
                            item.phoneNumber,
                            item.nationalCode,
                            item.signupAtDatePersian ? item.signupAtDatePersian.replaceAll("-", "/") : "",
                            item.signupAtTimePersian,
                            true,
                            item.avatar.downloadUrl,
                            item.selectedCityResponse ? item.selectedCityResponse.provinceName : "-",
                            item.selectedCityResponse ? item.selectedCityResponse.name : "-",
                            item.displayName
                        )
                    ])
                })
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setIsLoading(false)
        })
    }

    function handleChangePagination(newPage) {
        setPage(newPage)
        getUsersListFromServer()
        console.log("newPage", newPage)
    }

    const navigate = useNavigate()

    function showUserInformation(id) {
        let fullName = ""
        usersListData.map((item) => {
            if (item.id === id) {
                fullName = item.fullName
            }
        })
        navigate(RouteHelper.UserInformation.globalUrl.replace(":id", id),
            {state: {fullName: fullName}, replace: false}
        )

    }

    const [openStatisticsModal, setOpenStatisticsModal] = useState(false);

    function handleOpenStatisticsModal() {
        setOpenStatisticsModal(true)
    }

    function handleCloseStatisticsModal() {
        setOpenStatisticsModal(false)
    }

    const [selectDisplayType, setSelectDisplayType] = useState(false);


    const location = useLocation();
    const [currentPath, setCurrentPath] = useState(location.pathname)
    const [currentSearch, setCurrentSearch] = useState(location.search)

    function checkingFiltersAndSearches() {
        const filters = []

        if (typeof page !== 'undefined' && page > 0) {
            filters.push(`page=${page}`)
        }
        if (fullNameFilter && fullNameFilter.length > 0) {
            filters.push(`fullName=${fullNameFilter}`)
        }
        if (phoneNumberFilter && phoneNumberFilter.length > 0) {
            filters.push(`phoneNumber=${phoneNumberFilter}`)
        }

        let filterItems = ""
        if (filters && filters.length > 0) {
            filters.map((item, index) => {
                if (index === 0)
                    filterItems = item
                else
                    filterItems = filterItems + `&${item}`
            })
        }


        navigate(`/panel/users-list?${filterItems}`)
    }

    function handleDeleteAllFilters() {
        setPhoneNumberFilter("")
    }

    return (
        <>
            <Helmet>
                <title>{RouteHelper.UsersList.name}</title>
            </Helmet>

            <RaikoDefaultDialogPage
                onClose={handleCloseStatisticsModal}
                open={openStatisticsModal}
                dialogSize={DialogSize.LARGE}
            >
                <RaikoBaseDialogContentContainer>
                    <UserStatistics title="تعداد نصب سالانه"/>
                </RaikoBaseDialogContentContainer>

            </RaikoDefaultDialogPage>

            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                    <RaikoBreadcrumb breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(
                            RouteHelper.UsersList.name,
                            ""
                        ),
                    ]}/>
                    <UserInstallationSummary/>
                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoTableTitleContainer
                                title={"کاربران"}
                                amount={numberOfItems}
                                hasCreateNewItem
                                createNewItemTitle={"آمار"}
                                handleCreateNewItem={handleOpenStatisticsModal}
                                hasSelectDisplayType
                                selectDisplayType={selectDisplayType}
                                setSelectDisplayType={setSelectDisplayType}
                            />
                            <RaikoTableSearchContainer
                                value={fullNameFilter}
                                setValue={setFullNameFilter}
                                labelText={"نام و نام خانوادگی"}
                                hasFilter
                                handleDeleteAllFilters={handleDeleteAllFilters}
                            >
                                <RaikoMobileInputOutlined
                                    labelText={"شماره همراه"}
                                    value={phoneNumberFilter}
                                    setValue={setPhoneNumberFilter}
                                />
                            </RaikoTableSearchContainer>
                            <RaikoCustomTable
                                isLoading={isLoading}
                                data={usersListData}
                                header={usersTableHeader}
                                rowClicked={showUserInformation}
                                pageCount={pageCount}
                                selectDisplayType={selectDisplayType}
                                newPage={page}
                                handlePaginationDefaultValue={handleChangePagination}
                            >
                                <RaikoGridThreeColumn className={css`padding: 3px`}>
                                    {usersListData.map((item, index) => {
                                        return <RaikoCardInfoTypeOne
                                            key={index}
                                            title={item.fullName}
                                            titleLabel={item.phoneNumber}
                                            hasAvatar

                                            avatarSource={item.avatar}
                                            status
                                            statusText={"فعال"}
                                            statusType={item.enabled ?
                                                RaikoCardInfoTypeOneStatusTypes.SUCCESS :
                                                RaikoCardInfoTypeOneStatusTypes.ERROR}
                                            onClick={_ => {
                                                showUserInformation(item.id)
                                            }}
                                        />
                                    })}
                                </RaikoGridThreeColumn>
                            </RaikoCustomTable>
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}

const usersTableHeader = [
    {
        id: "number",
        label: "#"
    },
    {
        id: "fullName",
        label: "نام و نام خانوادگی"
    },
    {
        id: "displayName",
        label: "نام کاربری",
    },
    {
        id: "province",
        label: "استان",
    },
    {
        id: "city",
        label: "شهر",
    },
    {
        id: "phoneNumber",
        label: "شماره همراه"
    },
    {
        id: "signupAt",
        label: "تاریخ ثبت نام"
    },
    {
        id: "enabled",
        label: "وضعیت"
    },
]